import { useReducer } from 'react';
import languageStore, {
  INITIAL_LANGUAGE,
} from '../store/language/languageStore';
import {
  fallBackLanguage,
  Language,
  LanguageStoreKind,
  LanguageStoreType,
} from 'src/store/language/languageStore.types';

export interface LanguageHook {
  state: LanguageStoreType;
  actions: {
    setLanguage: (lang: string) => void;
    setFirstLanguageChangeDone: (done: boolean) => void;
  };
}

const useLanguageHook = (): LanguageHook => {
  const [state, dispatch] = useReducer(languageStore, INITIAL_LANGUAGE);

  const setHTMLLanguage = (lang: string): void => {
    const htmlElement = document.getElementsByTagName('html').item(0);
    if (htmlElement) {
      htmlElement.setAttribute('lang', lang.toLowerCase());
    }
  };

  const setLanguage = (lang: string): void => {
    const selectedLanguage = lang.toLowerCase().startsWith('de')
      ? Language.DE
      : fallBackLanguage;
    dispatch({
      type: LanguageStoreKind.INITIAL,
      payload: selectedLanguage,
    });
    setHTMLLanguage(selectedLanguage);
  };

  const setFirstLanguageChangeDone = (done: boolean): void => {
    dispatch({
      type: LanguageStoreKind.UPDATE_FIRST_CHANGE_DONE,
      payload: done,
    });
  };

  return {
    state,
    actions: { setLanguage, setFirstLanguageChangeDone },
  };
};

export default useLanguageHook;
